<template>
  <div class="group-buying">
    <div class="page-help content">
      <h2>{{ $t("newFranchise.groupBuying") }}</h2>
      <div class="wrapp-buying">
        <div class="buying">
          <div>{{ $t("newFranchise.groupBuyingP1") }}</div>
          <div>{{ $t("newFranchise.groupBuyingP2") }}</div>
          <div>{{ $t("newFranchise.groupBuyingP3") }}</div>
        </div>
        <div class="buying">
          <div>{{ $t("newFranchise.groupBuyingP4") }}</div>
          <div>{{ $t("newFranchise.groupBuyingP5") }}</div>
        </div>
      </div>
      <div class="wrapp-role">
        <div class="role">
          <h3>{{ $t("newFranchise.roleFranchisee") }}</h3>
          <div class="item">
            <img src="@/assets/newImges/correct.svg" alt="" srcset="" />
            <p>{{ $t("newFranchise.roleP1") }}</p>
          </div>
          <div class="item">
            <img src="@/assets/newImges/correct.svg" alt="" srcset="" />
            <p>{{ $t("newFranchise.roleP2") }}</p>
          </div>
          <div class="item">
            <img src="@/assets/newImges/correct.svg" alt="" srcset="" />
            <p>{{ $t("newFranchise.roleP3") }}</p>
          </div>
        </div>
        <div class="role">
          <h3>{{ $t("newFranchise.dontDoFranchisee") }}</h3>
          <div class="item">
            <img src="@/assets/newImges/VectorRed.svg" alt="" srcset="" />
            <p>{{ $t("newFranchise.dontDoP1") }}</p>
          </div>
          <div class="item">
            <img src="@/assets/newImges/VectorRed.svg" alt="" srcset="" />
            <p>{{ $t("newFranchise.dontDoP2") }}</p>
          </div>
          <div class="item">
            <img src="@/assets/newImges/VectorRed.svg" alt="" srcset="" />
            <p>{{ $t("newFranchise.dontDoP3") }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
.group-buying {
  width: 100%;
  font-family: Outfit;
  text-align: left;
  padding-top: 174px;
  margin-bottom: 269px;
  background-image: url("../../assets/newImges/EllipseLeft.png") !important;
  background-repeat: no-repeat;
  background-position: left 65%;
  .content {
    h2 {
      font-weight: 500;
      font-style: Medium;
      font-size: 64px;
      line-height: 100%;
      letter-spacing: 0%;
      max-width: 607px;
      margin: 0;
      margin-bottom: 77px;
      color: $blue-1000;
    }
    .wrapp-buying {
      display: flex;
      justify-content: space-between;
      margin-bottom: 269px;

      .buying {
        width: calc(50% - 15px);

        div {
          color: $blue-400;
          font-family: Outfit;
          font-weight: 400;
          font-style: Regular;
          font-size: 25px;
          line-height: 40px;
          letter-spacing: 0%;
          background-color: $gray-blue-400;
          border-radius: 12px;
          padding: 16px 52px;
          margin-bottom: 13px;
        }
      }
    }
    .wrapp-role {
      display: flex;
      .role {
        box-sizing: border-box;
        width: 50%;
        h3 {
          font-weight: 500;
          font-style: Medium;
          font-size: 36px;

          line-height: 100%;
          letter-spacing: 0%;
          color: $blue-1000;
          margin: 0;
          margin-bottom: 72px;
        }
        .item {
          font-weight: 400;
          font-style: Regular;
          font-size: 25px;
          line-height: 40px;
          letter-spacing: 0%;
          color: $blue-400;
          display: flex;
          //   align-items: center;
          margin-bottom: 33px;
          img {
            margin-right: 14px;
            margin-top: 7px;
            height: fit-content;
          }
          p {
            margin: 0;
          }
        }
      }
    }
  }
}
@media only screen and (max-width: 1300px) {
  .group-buying {
    padding-top: 124px;
    margin-bottom: 200px;

    .content {
      h2 {
        font-size: 54px;
        line-height: 100%;
        margin-bottom: 67px;
      }
      .wrapp-buying {
        margin-bottom: 180px;

        .buying {
          width: calc(50% - 15px);

          div {
            font-size: 20px;
            line-height: 30px;
            border-radius: 12px;
            padding: 16px 22px;
            margin-bottom: 13px;
          }
        }
      }
      .wrapp-role {
        .role {
          box-sizing: border-box;
          width: 50%;
          h3 {
            font-weight: 500;
            font-style: Medium;
            font-size: 30px;

            line-height: 100%;
            margin-bottom: 52px;
          }
          .item {
            line-height: 35px;
            margin-bottom: 28px;
            img {
              margin-right: 14px;
              margin-top: 5px;
              height: fit-content;
            }
          }
        }
      }
    }
  }
}
@media only screen and (max-width: 750px) {
  .group-buying {
    padding-top: 74px;
    margin-bottom: 100px;
    background-position: left 50%;
    .content {
      h2 {
        font-size: 34px;
        line-height: 100%;
        margin-bottom: 47px;
      }
      .wrapp-buying {
        margin-bottom: 100px;
        flex-direction: column;
        .buying {
          width: 100%;

          div {
            font-size: 20px;
            line-height: 30px;
            border-radius: 12px;
            padding: 16px 22px;
            margin-bottom: 13px;
          }
        }
      }
      .wrapp-role {
        flex-direction: column;
        .role {
          box-sizing: border-box;
          width: 100%;
          margin-bottom: 60px;
          h3 {
            font-weight: 500;
            font-style: Medium;
            font-size: 30px;

            line-height: 100%;
            margin-bottom: 52px;
          }
          .item {
            font-weight: 400;
            font-style: Regular;
            font-size: 20px;
            line-height: 30px;
            letter-spacing: 0%;
            //   align-items: center;
            margin-bottom: 28px;
            img {
              margin-right: 14px;
              margin-top: 5px;
              height: fit-content;
            }
          }
        }
      }
    }
  }
}
</style>
